import React from 'react';

function NotesInput(props) {

  const {notes, notesPlaceholder} = props.data;
  const {handleKeyUp} = props;

  return  (
    <div className="row">
      <div className="col-xs-12">
        <div className="nppe2-fc-notes">

          <div className="nppe2-fc-sub-title">
            {notes}
          </div>

          <textarea
            name="nppe2-fc-notes"
            placeholder={notesPlaceholder}
            onKeyUp={handleKeyUp}
          >
          </textarea>

        </div>
      </div>
    </div>
  )
}

export default NotesInput;
